import { render, staticRenderFns } from "./ParticlesBlock.vue?vue&type=template&id=b229d1fa&scoped=true&"
import script from "./ParticlesBlock.vue?vue&type=script&lang=ts&"
export * from "./ParticlesBlock.vue?vue&type=script&lang=ts&"
import style0 from "./ParticlesBlock.vue?vue&type=style&index=0&id=b229d1fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b229d1fa",
  null
  
)

export default component.exports